import { useState } from 'react'
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
/**
 * این کامپوننت برای دریافت عکس از کاربر به فرمت
 *  "jpeg/png"
 * است 
 */
export default function InputPic({ label, name, defaultValue, handelValue }) {

    const [error, setError] = useState("")

    const [colorerror, setColorerror] = useState('')

    const hedelonCheng = (event) => {
        // //console.log(URL.createObjectURL(event.target.files[0]));
        if (event.target.files[0]) {
            const vlaue = event.target.files[0]

            const reder = new FileReader()
            reder.readAsDataURL(vlaue)

            if (event.target.files[0].type === "image/png") {
                setError('عکس قابل ثبت است')
                setColorerror('green')
                reder.onload = e => {
                    handelValue(name, e.target.result)
                }

            }
            else if (event.target.files[0].type === "image/jpeg") {

                setError('عکس قابل ثبت است')
                setColorerror('green')
                reder.onload = e => {
                    handelValue(name, e.target.result)
                }
            }
            else {
                setError('عکس فقط به فرمت "jpeg/png" قابل ثبت است')
                setColorerror('red')
            }


        }
        else {
            setError('')
            setColorerror('')
            handelValue(name, '')

        }
    }

    return (
        <Form.Group>
            {
                label ? <Form.Label>{label}</Form.Label>
                    : null
            }
            <Form.File name={name ? name : ""} onChange={hedelonCheng} />
            {error ? <Form.Text style={{ color: colorerror }} >{error}</Form.Text> : null}
        </Form.Group>
    )
}
InputPic.propTypes = {
    /**لیبل اینپوت است */
    label: PropTypes.string,
    /**برای ارسال مقدار اولیه برای اینپوت است */
    defaultValue: PropTypes.string,
    /** نام اینپوت است */
    name: PropTypes.string,
    /** ارسال مقدار اینپوت به بالا است */
    handelValue: PropTypes.func
};